/**
 * Little helper for selecting the text of an element when clicked,
 * allowing easier copy-paste (while keeping the long-hold to copy for links on Android phones,
 * for example)
 * @module embed/select_on_click
 */

import { delegate, hasModifiers } from '@/lib/events';
import selectText from '@/lib/select_text';

const SELECTOR = '.js-select-on-click';

export default function setupSelectOnClick() {
  document.addEventListener(
    'click',
    delegate(SELECTOR, (event, target) => {
      if (!hasModifiers(event)) {
        event.preventDefault();
        selectText(target);
      }
    })
  );
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/embed/select_on_click.js